import { useFormik } from "formik";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  checkExistingAccount,
  createRecipient,
  getCustomerTypes,
  getUserRecipient,
  updateUserRecipient,
  getBankList,
  sendBankDetails,
  getCountryList,
  payoutBankList,
} from "../../../utils/Api";
import Bank_list from "../../../utils/Bank_list";
import { account_types_list } from "../../../utils/account_type";
import countryOptions from "../../../utils/AllCountryList";
import * as Yup from "yup";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import Select, { components } from "react-select";
import Autocomplete from "react-google-autocomplete";
import { useToast } from "../../common/RemitAssureToast";
import { getSelectedStreet, inputValidator } from "../../../hooks/validator";
import limits from "../../../hooks/limitations";

// Static country list
const countryList = [
  { name: "Australia", code: "AU", dialCode: "61" },
  { name: "Brazil", code: "BR", dialCode: "55" },
  { name: "China", code: "CN", dialCode: "86" },
  { name: "Ghana", code: "GH", dialCode: "233" },
  { name: "Kenya", code: "KE", dialCode: "254" },
  { name: "New Zealand", code: "NZ", dialCode: "64" },
  { name: "Nigeria", code: "NG", dialCode: "234" },
  { name: "Philippines", code: "PH", dialCode: "63" },
  { name: "Thailand", code: "TH", dialCode: "66" },
  { name: "Vietnam", code: "VN", dialCode: "84" },
];

const validator = Yup.object().shape({
  account_type: Yup.string().required(),
  business_name: Yup.string()
    .min(limits.business_name.min)
    .max(limits.business_name.max)
    .trim()
    .notOneOf([" "])
    .when("account_type", {
      is: "business",
      then: (schema) => schema.required("Business Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  bank_name: Yup.string()
    .min(limits.bank.min, "Minimum 3 symbols")
    .max(limits.bank.max, "Maximum 50 symbols")
    .required("Bank name is required")
    .trim(),
  bank_identifier: Yup.string()
    .max(limits.bank_identifier, "Maximum 40 symbols")
    .notRequired()
    .trim(),
  other_name: Yup.string()
    .min(limits.bank.min)
    .max(limits.bank.max)
    .test("value-test", (value, validationcontext) => {
      const {
        createError,
        parent: { bank_name },
      } = validationcontext;
      if (
        bank_name === "other" &&
        (value?.length < 3 ||
          value === undefined ||
          value === null ||
          value === " ")
      ) {
        return createError({ message: "Please enter bank name" });
      } else {
        return true;
      }
    })
    .trim(),
  account_number: Yup.string()
    .min(limits.account_number.min)
    .max(limits.account_number.max)
    .required(),
  address: Yup.string().trim(),
  first_name: Yup.string()
    .max(limits.name)
    .trim()
    .when("account_type", {
      is: "individual",
      then: (schema) => schema.required("First Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  last_name: Yup.string()
    .max(limits.name)
    .trim()
    .when("account_type", {
      is: "individual",
      then: (schema) => schema.required("Last Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  middle_name: Yup.string().max(limits.name).notRequired().trim(),
  email: Yup.string()
    .matches(/^[\w-+\.]+@([\w-]+\.)+[\w-]{2,5}$/, "Invalid email format")
    .max(limits.email.max)
    .notRequired(),
  flat: Yup.string().max(limits.flat).notRequired(),
  building: Yup.string().max(limits.building).required().trim(),
  street: Yup.string().max(limits.street).required().trim(),
  city: Yup.string().max(limits.city).required().trim(),
  postcode: Yup.string()
    .min(
      limits.user_zip?.min || 4,
      `Postcode must be at least ${limits.user_zip?.min || 4} characters`,
    )
    .max(
      limits.user_zip?.max || 9,
      `Postcode must be at most ${limits.user_zip?.max || 9} characters`,
    )
    .trim(),
  state: Yup.string().max(limits.state).required().trim(),
  country: Yup.string().max(limits.country).required(),
  country_code: Yup.string(),
});

const RecipientForm = ({
  section = "add-edit",
  nextAction = () => {},
  backHandler = () => {},
  currency = null,
}) => {
  const navigate = useNavigate();
  const isAfrican = true;

  const state = useLocation()?.state;
  const id = state?.id || false;
  const payoutCurrency =
    state?.payout_currency || sessionStorage.getItem("payout_currency") || null;
  console.log("🚀 ~ RecipientForm ~ payoutCurrency:", payoutCurrency);
  const transactionId = sessionStorage.getItem("transaction_id") || null;
  console.log("🚀 ~ RecipientForm ~ transactionId:", transactionId);

  const [prev_account_number, setPrevAcc] = useState("");
  const [is_account_existing, setExisting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [account_types, setAccountTypes] = useState(account_types_list);
  const [bankList, setBankList] = useState([]);
  const [selectedBankCode, setSelectedBankCode] = useState("");
  const [loadingBanks, setLoadingBanks] = useState(true);
  const [PrevEmail, setPrevEmail] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [payoutCountryList, setPayoutCountryList] = useState([]);
  const [payoutCurrencyOptions, setPayoutCurrencyOptions] = useState([]);
  const [selectedPayoutCountry, setSelectedPayoutCountry] = useState(null);
  const [loadingPayoutCountries, setLoadingPayoutCountries] = useState(false);
  const [loadingPayoutBanks, setLoadingPayoutBanks] = useState(false);
    const [payoutDetailLocked, setPayoutDetailLocked] = useState(false);
  const [bankIdentifierLabel, setBankIdentifierLabel] =
    useState("BIC, IFSC, etc");
  const [accountVerified, setAccountVerified] = useState(false);
  const [showVerifyBox, setShowVerifyBox] = useState(false);
  const [nameConfirmed, setNameConfirmed] = useState(false);
  const [nameHint, setNameHint] = useState({ text: "", color: "" });
  const { showToast } = useToast();
  const userHasInteracted = useRef(false);
  const isNGNRef = useRef(false);
  const fields = {
    account_type: "individual",
    business_name: "",
    bank_name: "",
    other_name: "",
    account_number: "",
    bank_identifier: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    email: "",
    flat: "",
    building: "",
    street: "",
    city: "",
    postcode: "",
    state: "",
    country: "Australia",
    country_code: "AU",
    address: "",
    recipient_name: "",
    payout_country: "",
    payout_currency: "",
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  } = useFormik({
    initialValues: fields,
    validationSchema: validator,
    onSubmit: async (values) => {
      if (showVerifyBox && !nameConfirmed) {
        showToast(
          "warning",
          "Warning",
          "Please confirm the recipient name before continuing.",
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
          },
        );
        return;
      }
      setLoading(true);
  let payload = { ...values };
    if (!payload.payout_country && selectedPayoutCountry?.value) {
        payload.payout_country = selectedPayoutCountry.value;
      }
      if (!payload.payout_currency) {
        const currencyFromOptions = payoutCurrencyOptions?.[0]?.value || "";
        if (currencyFromOptions) payload.payout_currency = currencyFromOptions;
      }
      if (
        (currency === "NGN" ||
          payoutCurrency === "NGN" ||
          values.payout_currency === "NGN") &&
        selectedBankCode
      ) {
        payload.bank_code = selectedBankCode;
      } else {
        const bank = bankList.filter((bank) => {
          return bank.label === values.bank_name;
        });
        if (bank.length > 0) {
          payload.bank_code = bank[0].code;
        } else payload.bank_code = "";
      }

      if (payload.account_type !== "business") {
        for (const key of [
          "business_name",
          "business_nature",
          "registration_date",
          "business_address",
          "registration_number",
          "registration_country",
        ]) {
          delete payload[key];
        }
      }

      if (payload.account_type === "business") {
        for (const key of ["first_name", "last_name", "middle_name"]) {
          delete payload[key];
        }
      }

      if (!payload.first_name) payload.first_name = "";
      if (!payload.last_name) payload.last_name = "";

      for (const key of [
        "other_name",
        "postcode",
        "address",
        "flat",
        "email",
        "recipient_name",
      ]) {
        if (!payload[key]) {
          delete payload[key];
        }
      }

      if (!payload.middle_name) delete payload.middle_name;

      if (payload.bank_name === "other") {
        payload.bank_name = payload.other_name;
      }

      try {
        if (id) {
          if (PrevEmail === payload.email) delete payload.email;
          let response = await updateUserRecipient(id, payload);
          setLoading(false);

          if (response) {
            if (response.code === "200") {
              showToast("success", "Success", "Successfully updated", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: true,
              });
              navigate("/user-recipients");
            } else {
              showToast("error", "Error", response?.message, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: true,
              });
            }
          }
        } else {
          if (section === "transfer" && transactionId) {
            payload.transaction_id = transactionId;
          }
          let response = await createRecipient({ ...payload });
          setLoading(false);

          if (response) {
            if (response.code === "200") {
              showToast(
                "success",
                "Success",
                "Successfully added new recipient",
                {
                  position: "bottom-right",
                  autoClose: 2000,
                  hideProgressBar: true,
                },
              );

              if (section !== "transfer") {
                navigate("/user-recipients");
              } else {
                nextAction(values, response.data);
              }
            } else {
              showToast("error", "Error", response?.message, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: true,
              });
            }
          } else {
            showToast(
              "error",
              "Error",
              "An error occurred while creating the recipient",
              {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: true,
              },
            );
            if (section === "transfer") backHandler();
          }
        }
      } catch (error) {
        setLoading(false);
        showToast("error", "Error", "An unexpected error occurred", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
        });
        if (section === "transfer") backHandler();
      }
    },
  });
  useEffect(() => {
    if (!isNGNRef.current) return;
    if (values.account_number.length < 4 || !values.bank_name) {
      setAccountVerified(false);
      setShowVerifyBox(false);
      setNameConfirmed(false);
      setNameHint({ text: "", color: "" });
      setFieldValue("recipient_name", "");
      setFieldValue("first_name", "");
      setFieldValue("last_name", "");
      setFieldValue("business_name", "");
    } else if (values.account_number.length < 10) {
      setAccountVerified(false);
      setShowVerifyBox(false);
      setNameConfirmed(false);
      setNameHint({ text: "", color: "" });
      setFieldValue("recipient_name", "");
      setFieldValue("first_name", "");
      setFieldValue("last_name", "");
      setFieldValue("business_name", "");
    }
  }, [
    values.account_number,
    values.bank_name,
    values.payout_country,
    values.payout_currency,
  ]);
  useEffect(() => {
    if (!isNGNRef.current) return;

    if (
      !values.account_number ||
      !values.bank_identifier ||
      !values.bank_name ||
      values.account_number.length !== 10
    ) {
      setAccountVerified(false);
      setShowVerifyBox(false);
      setNameConfirmed(false);
      setNameHint({ text: "", color: "" });

      setFieldValue("recipient_name", "");
      setFieldValue("first_name", "");
      setFieldValue("last_name", "");
      setFieldValue("business_name", "");

      return;
    }

    const timer = setTimeout(async () => {
      if (is_account_existing) return;
      try {
        setAccountVerified(false);
        setShowVerifyBox(false);
        setNameConfirmed(false);
        setNameHint({ text: "", color: "" });

        setFieldValue("recipient_name", "");
        setFieldValue("first_name", "");
        setFieldValue("last_name", "");
        setFieldValue("business_name", "");

        const payload = {
          code: values.bank_identifier,
          number: values.account_number,
          currency: "NGN",
        };

        const response = await sendBankDetails(payload);

        if (response?.code === "400") {
          showToast(
            "error",
            "Invalid Details",
            response?.message || "We could not verify your bank account name.",
          );
          return;
        }

        if (response?.code === "200") {
          const fullName = response?.data?.account_name || "";
          setFieldValue("recipient_name", fullName);

          if (values.account_type === "individual") {
            const parts = fullName.trim().split(" ");
            if (parts.length >= 2) {
              setFieldValue("first_name", parts[0]);
              setFieldValue("last_name", parts.slice(1).join(" "));
            } else if (parts.length === 1) {
              setFieldValue("first_name", parts[0]);
            }
          }

          if (values.account_type === "business") {
            setFieldValue("business_name", fullName);
          }

          setAccountVerified(true);

          if (userHasInteracted.current) {
            setShowVerifyBox(true);
            setNameConfirmed(false);
            setNameHint({
              text: "⬆ Please confirm this name",
              color: "#6414E9",
            });
          } else {
            setNameConfirmed(true);
            setShowVerifyBox(false);
            setNameHint({ text: "", color: "" });
          }

          return;
        }

        showToast(
          "error",
          "Error",
          response?.message || "Account verification failed",
        );
      } catch (error) {
        showToast("error", "Error", error?.message || "Something went wrong");
      }
    }, 800);

    return () => clearTimeout(timer);
  }, [
    values.account_number,
    values.bank_identifier,
    values.bank_name,
    values.payout_country,
    values.payout_currency,
  ]);

  // ── Load recipient data for edit ─────────────────────────────────
  useEffect(() => {
    if (!!id && bankList.length > 0) {
      const dataFetch = async () => {
        setLoading(true);
        const response = await getUserRecipient(id);
        if (response && response.code === "200") {
          const values = response.data;
          if (values.country === "Nigeria") {
            const find = bankList.find(
              (bank) => bank.label === values.bank_name,
            );
            if (!find) {
              values.bank_name = "other";
              values.other_name = values.bank_name;
            }
          }
          setPrevEmail(values.email || "");
          setPayoutDetailLocked(values.payout_detail === true);
          setValues(values);
          setPrevAcc(values.account_number);
          userHasInteracted.current = false;
          if (values.payout_country) {
            setSelectedPayoutCountry({
              label: values.payout_country,
              value: values.payout_country,
            });
          }

          if (values.payout_currency) {
            setPayoutCurrencyOptions([
              { label: values.payout_currency, value: values.payout_currency },
            ]);
          }
        }
        setLoading(false);
      };
      dataFetch();
    }
  }, [id, bankList]);

  // ── Fetch account types and bank list ───────────────────────────
  useEffect(() => {
    const fetchAccountTypes = async () => {
      const response = await getCustomerTypes();
      if (response && response.code === "200") {
        setAccountTypes(response.data);
      }
    };

    const fetchBankList = async () => {
      if (section === "transfer") {
        setLoadingBanks(false);
        return;
      }
      const response = await getBankList();
      if (response && response.code === "200") {
        const transformedBanks = response.data.data.map((bank) => ({
          label: bank.name,
          value: bank.name,
          code: bank.code,
        }));
        setBankList(transformedBanks);
      } else {
        setBankList(Bank_list);
      }
      setLoadingBanks(false);
    };

    fetchAccountTypes();
    fetchBankList();
  }, []);
  useEffect(() => {
    const fetchPayoutCountries = async () => {
      setLoadingPayoutCountries(true);
      const currencyParam = section === "transfer" ? payoutCurrency || "" : "";

      const response = await getCountryList(currencyParam);

      if (response && response.code === "200") {
        const countries = response.data || [];
        setPayoutCountryList(countries);
        if (section === "transfer" && payoutCurrency && countries.length > 0) {
          const firstCountry = countries[0];
          setSelectedPayoutCountry({
            label: firstCountry,
            value: firstCountry,
          });
          setFieldValue("payout_country", firstCountry);
          setFieldValue("payout_currency", payoutCurrency);

          setLoadingPayoutBanks(true);
          const bankResponse = await payoutBankList({
            country_name: firstCountry,
            ...(section === "transfer" && transactionId
              ? { transaction_id: transactionId }
              : {}),
          });
          if (bankResponse && bankResponse.code === 200) {
            const bankArray = bankResponse.data;
            const transformedBanks = bankArray.map((bank) => ({
              label: bank.bank_name,
              value: bank.bank_name,
              code: bank.bank_code,
              identifier: bank.bank_code,
              identifierType: bank.bank_identifier || "BIC, IFSC, etc",
            }));
            transformedBanks.push({ label: "Other", value: "other", code: "", identifier: "", identifierType: "BIC, IFSC, etc" });

            setBankList(transformedBanks);
  if (bankArray[0]?.bank_identifier) {
                              setBankIdentifierLabel(bankArray[0].bank_identifier);
                            } else {
                              setBankIdentifierLabel("BIC, IFSC, etc");
                            }
            const firstBank = bankArray[0];
            if (section === "transfer") {
              // ✅ Transfer: show only receive_currency from bank API response
              const receiveCurrency =
                firstBank?.receive_currency || payoutCurrency;
              setFieldValue("payout_currency", receiveCurrency);
              setPayoutCurrencyOptions([
                { label: receiveCurrency, value: receiveCurrency },
              ]);
            } else {
              // ✅ Add-edit: show all supports_currencies as dropdown options
              if (firstBank?.supports_currencies?.length > 0) {
                const sorted = [
                  firstBank.default_currency,
                  ...firstBank.supports_currencies.filter(
                    (c) => c !== firstBank.default_currency,
                  ),
                ];
                setPayoutCurrencyOptions(
                  sorted.map((c) => ({ label: c, value: c })),
                );
                setFieldValue(
                  "payout_currency",
                  firstBank.default_currency || "",
                );
              }
            }
          }
          setLoadingPayoutBanks(false);
        }
      }
      setLoadingPayoutCountries(false);
    };

    fetchPayoutCountries();
  }, []); // ✅ runs once on mount, section and payoutCurrency are stable from props/location

  // ── Bank selector styles ─────────────────────────────────────────
  const customStyles = {
    control: (base) => ({
      ...base,
      borderColor:
        errors.bank_name && touched.bank_name ? "red" : base.borderColor,
    }),
  };

  const Placeholder = (props) => {
    return <components.Placeholder {...props} />;
  };

  const changeHandler = (e) => {
    inputValidator(e, handleChange);
  };

  const validateAccount = (e) => {
    if (!!e.target.value && prev_account_number !== e.target.value) {
      checkExistingAccount({ account_number: e.target.value }).then((res) => {
        if (res.code === "400") {
          setExisting(true);
        } else {
          setExisting(false);
        }
      });
    }
    handleBlur(e);
  };

  const handlePhone = (e, coun) => {
    let mobileWithoutDialCode = e
      .substring(coun.dialCode.length)
      .replace(/[^0-9]/, "");
    handleChange({
      target: { name: "mobile", value: coun.dialCode + mobileWithoutDialCode },
    });
    setFieldValue("country", coun.name);
    if (values.country_code.toLowerCase() != coun.countryCode.toLowerCase()) {
      handleChange({
        target: { name: "country_code", value: coun.countryCode.toLowerCase() },
      });
      handleReset();
    }
  };

  const countryHandler = (e) => {
    const selected = countryList.find((country) => {
      return country.name === e.target.value;
    });
    handleChange(e);
    if (selected) {
      setFieldValue("country_code", selected.code);
    }
    handleReset();
  };

  const handleReset = () => {
    const clear_fields = [
      "street",
      "state",
      "city",
      "postcode",
      "building",
      "flat",
      "address",
    ];
    clear_fields.forEach((field) => {
      setFieldValue(field, "");
    });
  };
  const handleCancel = () => {
    if (section === "transfer") {
      // ✅ Reset all form fields before going back
      setFieldValue("account_type", "individual");
      setFieldValue("bank_name", "");
      setFieldValue("account_number", "");
      setFieldValue("bank_identifier", "");
      setFieldValue("first_name", "");
      setFieldValue("last_name", "");
      setFieldValue("middle_name", "");
      setFieldValue("business_name", "");
      setFieldValue("email", "");
      setFieldValue("flat", "");
      setFieldValue("building", "");
      setFieldValue("street", "");
      setFieldValue("city", "");
      setFieldValue("postcode", "");
      setFieldValue("state", "");
      setFieldValue("country", "Australia");
      setFieldValue("country_code", "AU");
      setFieldValue("address", "");
      setFieldValue("recipient_name", "");
      setFieldValue("payout_country", "");
      setFieldValue("payout_currency", "");
      setAccountVerified(false);
      setShowVerifyBox(false);
      setNameConfirmed(false);
      setNameHint({ text: "", color: "" });
      setExisting(false);
      setSelectedPayoutCountry(null);
      setPayoutCurrencyOptions([]);
      setBankList([]);
      setTimeout(() => {
        setFieldTouched("bank_name", false);
        setFieldTouched("account_number", false);
        setFieldTouched("bank_identifier", false);
        setFieldTouched("first_name", false);
        setFieldTouched("last_name", false);
        setFieldTouched("middle_name", false);
        setFieldTouched("business_name", false);
        setFieldTouched("building", false);
        setFieldTouched("street", false);
        setFieldTouched("city", false);
        setFieldTouched("state", false);
      }, 0);
      backHandler();
    } else {
      navigate("/user-recipients");
    }
  };
  const resetVerificationFields = () => {
    userHasInteracted.current = true;
    setAccountVerified(false);
    setShowVerifyBox(false);
    setNameConfirmed(false);
    setNameHint({ text: "", color: "" });
    setFieldValue("recipient_name", "");
    setFieldValue("first_name", "");
    setFieldValue("last_name", "");
    setFieldValue("middle_name", "");
    setFieldValue("business_name", "");
    setExisting(false);
    setTimeout(() => {
      setFieldTouched("account_number", false);
      setFieldTouched("bank_identifier", false);
    }, 0);
  };
  useEffect(() => {
    if (id) return;
    setFieldValue("first_name", "");
    setFieldValue("last_name", "");
    setFieldValue("middle_name", "");
    setFieldValue("business_name", "");
    setFieldValue("recipient_name", "");
    setFieldValue("bank_name", "");
    setFieldValue("account_number", "");
    setFieldValue("bank_identifier", "");
    setAccountVerified(false);
    setShowVerifyBox(false);
    setNameConfirmed(false);
    setNameHint({ text: "", color: "" });

    // Reset touched so validation errors don't show on empty fields
    setTimeout(() => {
      setFieldTouched("first_name", false);
      setFieldTouched("last_name", false);
      setFieldTouched("middle_name", false);
      setFieldTouched("business_name", false);
      setFieldTouched("bank_name", false);
      setFieldTouched("account_number", false);
      setFieldTouched("bank_identifier", false);
    }, 0);
  }, [values.account_type]);
  const handleConfirmName = () => {
    setNameConfirmed(true);
    setShowVerifyBox(false);
    setNameHint({ text: "", color: "" });
    setAccountVerified(true);
  };
  const handleNameEdit = (e) => {
    if (accountVerified) return;
    changeHandler(e);
  };
  const isNGN =
    values.payout_country === "Nigeria" ||
    currency === "NGN" ||
    payoutCurrency === "NGN";
  isNGNRef.current = isNGN;
  const showRecipientSection =
    !is_account_existing && (!isNGN || (isNGN && accountVerified));
  return (
    <>
      {loading && (
        <div className="loader-overly">
          <div className="loader"></div>
        </div>
      )}

      <section className="showrecepient">
        <div className="form-head mb-4">
          <h2 className="text-black font-w600 mb-0">
            <b>{id ? "Update" : "Add"} Recipient</b>
            {section !== "transfer" && (
              <NavLink to="/user-recipients">
                <button className="start-form-button back-btn">
                  <MdOutlineKeyboardBackspace />
                  Back
                </button>
              </NavLink>
            )}
          </h2>
        </div>

        <form noValidate className="single-recipient" onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-body">
              {/* ── Account Type ───────────────────────────────────── */}
              <div className="row each-row">
                <h5>Account Type</h5>
                <div className="col-md-6 col-lg-6 col-sm-12">
                  {!!id ? (
                    <input
                      type="text"
                      name="account_type"
                      id="account_type"
                      className="form-control bg-transparent text-capitalize"
                      value={values.account_type}
                      disabled
                      readOnly
                    />
                  ) : (
                    <Form.Select
                      name="account_type"
                      value={values.account_type}
                      onChange={handleChange}
                      className="form-control bg-transparent text-capitalize"
                      id="account_type"
                    >
                      {account_types.map((type, index) => (
                        <option
                          value={type.value}
                          key={index}
                          className="text-capitalize"
                        >
                          {type.text}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </div>
              </div>

              {/* ── Bank Information ───────────────────────────────── */}
              <div className="row each-row">
                <h5>Bank Information</h5>
                {/* Payout Country — only shown outside transfer flow */}
                <div className="col-md-6">
                  <div className="input_field">
                    <p className="get-text">
                      Payout Country<span className="text-danger">*</span>
                    </p>
                    <Select
                      isLoading={loadingPayoutCountries}
                      isDisabled={loadingPayoutCountries || (!!id && payoutDetailLocked)}
                      options={payoutCountryList.map((c) => ({
                        label: c,
                        value: c,
                      }))}
                      onChange={(selected) => {
                        setSelectedPayoutCountry(selected);
                        setFieldValue("payout_country", selected?.value || "");
                        setFieldValue("payout_currency", "");
                        setPayoutCurrencyOptions([]);
                        setBankList([]);
                        setFieldValue("bank_name", "");
                        setFieldValue("account_number", "");
                        setFieldValue("bank_identifier", "");
                        resetVerificationFields();

                        if (!selected) return;

                        setLoadingPayoutBanks(true);
                        payoutBankList({
                          country_name: selected.value,
                          ...(section === "transfer" && transactionId
                            ? { transaction_id: transactionId }
                            : {}),
                        }).then((response) => {
                          if (response && response.code === 200) {
                            const bankArray = response.data;

                            const transformedBanks = bankArray.map((bank) => ({
                              label: bank.bank_name,
                              value: bank.bank_name,
                              code: bank.bank_code,
                              identifier: bank.bank_code,
                              identifierType:
                                bank.bank_identifier || "BIC, IFSC, etc",
                            }));
                                                        transformedBanks.push({ label: "Other", value: "other", code: "", identifier: "", identifierType: "BIC, IFSC, etc" });

                                    setBankList(transformedBanks);

                            if (bankArray[0]?.bank_identifier) {
                              setBankIdentifierLabel(bankArray[0].bank_identifier);
                            } else {
                              setBankIdentifierLabel("BIC, IFSC, etc");
                            }
                      const firstBank = bankArray[0];
if (section === "transfer") {
  // Transfer: show only receive_currency
  const receiveCurrency =
    firstBank?.receive_currency || payoutCurrency || "";
  setFieldValue("payout_currency", receiveCurrency);
  setPayoutCurrencyOptions([
    { label: receiveCurrency, value: receiveCurrency },
  ]);
} else {
  // Add-edit: show all supported currencies
  if (firstBank?.supports_currencies?.length > 0) {
    const sorted = [
      firstBank.default_currency,
      ...firstBank.supports_currencies.filter(
        (c) => c !== firstBank.default_currency,
      ),
    ];
    const currencies = sorted.map((c) => ({
      label: c,
      value: c,
    }));
    setPayoutCurrencyOptions(currencies);
    setFieldValue(
      "payout_currency",
      firstBank.default_currency || "",
    );
  }
}
                          }
                          setLoadingPayoutBanks(false);
                        });
                      }}
                      value={selectedPayoutCountry}
                      placeholder="Select payout country"
                      name="payout_country"
                    />
                  </div>
                </div>
                {/* Payout Currency — only shown outside transfer flow */}
                <div className="col-md-6">
                  <div className="input_field">
                    <p className="get-text">
                      Payout Currency<span className="text-danger">*</span>
                    </p>
                    <Select
                      isLoading={loadingPayoutBanks}
                    isDisabled={
                        loadingPayoutBanks || bankList.length === 0 || (!!id && payoutDetailLocked)
                      }
                      options={payoutCurrencyOptions}
                      onChange={(e) =>
                        setFieldValue("payout_currency", e?.value || "")
                      }
                      value={
                        values.payout_currency
                          ? {
                              label: values.payout_currency,
                              value: values.payout_currency,
                            }
                          : null
                      }
                      placeholder="Select currency"
                      name="payout_currency"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="input_field">
                    <p className="get-text">
                      Bank Name<span className="text-danger">*</span>
                    </p>
                    {values.payout_country ? (
                      <Select
                        isLoading={loadingPayoutBanks || loadingPayoutCountries}
                        isDisabled={
                          loadingPayoutBanks ||
                          loadingPayoutCountries ||
                          bankList.length === 0
                        }
                        options={bankList}
                        onChange={(e) => {
                          console.log("🏦 Bank selected:", e);
                          console.log("🏦 identifierType:", e.identifierType);
                          console.log(
                            "🏦 full bank object:",
                            JSON.stringify(e),
                          );
                          setFieldValue("account_number", "");
                          setFieldValue("bank_identifier", "");
                            setFieldValue("other_name", "");
                          resetVerificationFields();
                          handleChange({
                            target: { name: "bank_name", value: e.value },
                          });
                          setFieldValue(
                            "bank_identifier",
                            e.identifier || e.code || "",
                          );
                          setSelectedBankCode(e.code || "");
                        }}
                        value={
                          values.bank_name
                            ? {
                                label: values.bank_name,
                                value: values.bank_name,
                              }
                            : ""
                        }
                        name="bank_name"
                        styles={customStyles}
                        components={{ Placeholder }}
                        placeholder={
                          loadingPayoutBanks
                            ? "Loading banks..."
                            : bankList.length === 0
                              ? values.payout_country
                                ? "Loading banks..."
                                : "Select payout country first"
                              : "Select bank"
                        }
                        onBlur={handleBlur}
                      />
                    ) : section === "add-edit" ? (
                      <input
                        type="text"
                        name="bank_name"
                        value={values?.bank_name}
                        onChange={(e) => {
                          setFieldValue("account_number", "");
                          setFieldValue("bank_identifier", "");
                          resetVerificationFields();
                          changeHandler(e);
                        }}
                        maxLength={50}
                        className={`form-control bg-transparent 
      ${touched.bank_name && errors.bank_name ? "is-invalid" : ""}
      ${touched.bank_name && !errors.bank_name ? "is-valid" : ""}`}
                        onBlur={handleBlur}
                        autoComplete="off"
                      />
                    ) : (
                      <input
                        type="text"
                        name="bank_name"
                        value={values?.bank_name}
                        onChange={(e) => {
                          setFieldValue("account_number", "");
                          setFieldValue("bank_identifier", "");
                          resetVerificationFields();
                          changeHandler(e);
                        }}
                        maxLength={50}
                        className={`form-control bg-transparent 
      ${touched.bank_name && errors.bank_name ? "is-invalid" : ""}
      ${touched.bank_name && !errors.bank_name ? "is-valid" : ""}`}
                        onBlur={handleBlur}
                        autoComplete="off"
                      />
                    )}
                  </div>
                </div>

{values.bank_name === "other" && (
                  <div className="col-md-4">
                    <div className="input_field">
                      <p className="get-text">
                        Other Bank Name<span style={{ color: "red" }}>*</span>
                      </p>
                      <input
                        type="text"
                        name="other_name"
                        value={values?.other_name}
                        onChange={changeHandler}
                        maxLength={50}
                        className={clsx(
                          "form-control bg-transparent",
                          {
                            "is-invalid":
                              touched.other_name && errors.other_name,
                          },
                          {
                            "is-valid":
                              touched.other_name && !errors.other_name,
                          },
                        )}
                        onBlur={handleBlur}
                      />
                    </div>
                  </div>
                )}

                <div className="col-md-4">
                  <div className="input_field">
                    <p className="get-text">
                      Account number<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="account_number"
                      value={values?.account_number}
                      onChange={(e) => {
                        if (
                          values.payout_country === "Nigeria" ||
                          currency === "NGN" ||
                          payoutCurrency === "NGN"
                        ) {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                        }
                        resetVerificationFields();
                        changeHandler(e);
                      }}
                      maxLength={
                        values.payout_country === "Nigeria" ||
                        currency === "NGN" ||
                        payoutCurrency === "NGN"
                          ? 10
                          : 30
                      }
                      onBlur={(e) => validateAccount(e)}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            (touched.account_number && errors.account_number) ||
                            is_account_existing ||
                            ((values.payout_country === "Nigeria" ||
                              currency === "NGN" ||
                              payoutCurrency === "NGN") &&
                              values.account_number.length > 0 &&
                              values.account_number.length < 10),
                        },
                        {
                          "is-valid":
                            touched.account_number &&
                            !errors.account_number &&
                            (values.payout_country === "Nigeria" ||
                            currency === "NGN" ||
                            payoutCurrency === "NGN"
                              ? values.account_number.length === 10
                              : true),
                        },
                      )}
                    />
                    {is_account_existing && (
                      <p className="text-danger fs-6 mt-1 ms-2">
                        Recipient with this account number already exists!
                      </p>
                    )}
                    {(values.payout_country === "Nigeria" ||
                      currency === "NGN" ||
                      payoutCurrency === "NGN") &&
                      values.account_number.length > 0 &&
                      values.account_number.length < 10 && (
                        <p className="text-danger fs-6 mt-1 ms-2">
                          Account number must be exactly 10 digits
                        </p>
                      )}
                    {/* ✓ Account verified badge */}
                    {accountVerified && (
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 500,
                          marginTop: 5,
                          color: "#6414E9",
                        }}
                      >
                        ✓ Account verified
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="input_field">
                    <p className="get-text">
                      Bank Identifier ({bankIdentifierLabel}) (optional)
                    </p>
                    <input
                      type="text"
                      name="bank_identifier"
                      value={values?.bank_identifier}
                      onChange={(e) => {
                        if (
                          values.payout_country === "Nigeria" ||
                          currency === "NGN" ||
                          payoutCurrency === "NGN"
                        )
                          return;
                        resetVerificationFields();
                        changeHandler(e);
                      }}
                      readOnly={
                        values.payout_country === "Nigeria" ||
                        currency === "NGN" ||
                        payoutCurrency === "NGN"
                      }
                      style={
                        values.payout_country === "Nigeria" ||
                        currency === "NGN" ||
                        payoutCurrency === "NGN"
                          ? {
                              backgroundColor: "#e9ecef",
                              cursor: "not-allowed",
                            }
                          : {}
                      }
                      maxLength={limits.bank_identifier}
                      onBlur={(e) => validateAccount(e)}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            values.bank_identifier &&
                            touched.bank_identifier &&
                            errors.bank_identifier,
                        },
                        {
                          "is-valid":
                            values.bank_identifier &&
                            touched.bank_identifier &&
                            !errors.bank_identifier,
                        },
                      )}
                    />
                  </div>
                </div>
              </div>

              {/* ── Recipient Details (Individual) ─────────────────── */}
              {values.account_type === "individual" && showRecipientSection && (
                <div className="row each-row">
                  <h5>Recipient Details</h5>

                  {/*
                    Flex wrapper:
                    - Left side: 3 name inputs in a grid
                    - Right side: verify callout (appears only when needed)
                  */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 16,
                      width: "100%",
                    }}
                  >
                    {/* Name fields grid */}
                    <div
                      style={{
                        flex: 1,
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gap: 16,
                      }}
                    >
                      {/* First Name */}
                      <div className="input_field">
                        <p className="get-text">
                          First Name<span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="first_name"
                          value={values.first_name}
                          onChange={handleNameEdit}
                          onBlur={handleBlur}
                          readOnly={accountVerified}
                          maxLength={limits.name}
                          style={
                            showVerifyBox && !nameConfirmed
                              ? { cursor: "not-allowed", color: "#5a6a8a" }
                              : {}
                          }
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                touched.first_name && errors.first_name,
                            },
                            {
                              "is-valid":
                                touched.first_name && !errors.first_name,
                            },
                          )}
                        />
                        {/* Show hint only on first name field */}
                        {nameHint.text && !nameConfirmed && (
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 500,
                              marginTop: 5,
                              color: nameHint.color,
                            }}
                          >
                            {nameHint.text}
                          </div>
                        )}
                        {nameConfirmed && accountVerified && (
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 500,
                              marginTop: 5,
                              color: "#6414E9",
                            }}
                          >
                            ✓ Name confirmed
                          </div>
                        )}
                      </div>

                      {/* Middle Name */}
                      <div className="input_field">
                        <p className="get-text">Middle Name (optional)</p>
                        <input
                          type="text"
                          name="middle_name"
                          value={values.middle_name}
                          onChange={changeHandler}
                          onBlur={handleBlur}
                          maxLength={limits.name}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                touched.middle_name &&
                                errors.middle_name &&
                                values.middle_name !== "",
                            },
                            {
                              "is-valid":
                                touched.middle_name &&
                                !errors.middle_name &&
                                values.middle_name !== "",
                            },
                          )}
                        />
                      </div>

                      {/* Last Name */}
                      <div className="input_field">
                        <p className="get-text">
                          Last Name<span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="last_name"
                          value={values.last_name}
                          onChange={handleNameEdit}
                          onBlur={handleBlur}
                          readOnly={accountVerified}
                          maxLength={limits.name}
                          style={
                            showVerifyBox && !nameConfirmed
                              ? { cursor: "not-allowed", color: "#5a6a8a" }
                              : {}
                          }
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                touched.last_name && errors.last_name,
                            },
                            {
                              "is-valid":
                                touched.last_name && !errors.last_name,
                            },
                          )}
                        />
                      </div>
                    </div>

                    {/* ── Verify Callout Box ── */}
                    {showVerifyBox && !nameConfirmed && (
                      <div style={calloutStyle}>
                        <div style={calloutTitleStyle}>
                          <span>△</span> Please verify
                        </div>
                        <div style={calloutBodyStyle}>
                          This name was auto-filled from your bank records.
                          Confirm it looks correct before continuing.
                        </div>
                        <button
                          type="button"
                          style={calloutBtnStyle}
                          onClick={handleConfirmName}
                        >
                          Looks correct ✓
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ── Business Information ───────────────────────────── */}
              {values.account_type === "business" && showRecipientSection && (
                <div className="row each-row">
                  <h5>Business Details</h5>
                  <div className="col-md-4 col-lg-4 col-sm-6">
                    <div className="input_field">
                      <p className="get-text">
                        Name of business
                        <span style={{ color: "red" }}>*</span>
                      </p>
                      <input
                        type="text"
                        name="business_name"
                        id="business_name"
                        value={values.business_name}
                        onChange={changeHandler}
                        maxLength={limits.business_name.max}
                        readOnly={accountVerified}
                        style={
                          showVerifyBox && !nameConfirmed
                            ? { cursor: "not-allowed", color: "#5a6a8a" }
                            : {}
                        }
                        className={clsx(
                          "form-control bg-transparent",
                          {
                            "is-invalid":
                              touched.business_name && errors.business_name,
                          },
                          {
                            "is-valid":
                              touched.business_name && !errors.business_name,
                          },
                        )}
                        onBlur={handleBlur}
                      />
                      {/* Name hint for business */}
                      {nameHint.text && !nameConfirmed && (
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 500,
                            marginTop: 5,
                            color: nameHint.color,
                          }}
                        >
                          {nameHint.text}
                        </div>
                      )}
                      {nameConfirmed && accountVerified && (
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 500,
                            marginTop: 5,
                            color: "#0AEDC7",
                          }}
                        >
                          ✓ Name confirmed
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Callout for business account type */}
                  {showVerifyBox &&
                    !nameConfirmed &&
                    values.account_type === "business" && (
                      <div
                        className="col-md-4 col-lg-4 col-sm-6"
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          paddingBottom: 4,
                        }}
                      >
                        <div style={calloutStyle}>
                          <div style={calloutTitleStyle}>
                            <span>△</span> Please verify
                          </div>
                          <div style={calloutBodyStyle}>
                            This name was auto-filled from your bank records.
                            Confirm it looks correct before continuing.
                          </div>
                          <button
                            type="button"
                            style={calloutBtnStyle}
                            onClick={handleConfirmName}
                          >
                            Looks correct ✓
                          </button>
                        </div>
                      </div>
                    )}
                </div>
              )}
              {/* ── Email ──────────────────────────────────────────── */}
              {showRecipientSection && (
                <div className="row each-row">
                  <div className="col-md-4">
                    <div className="input_field">
                      <p className="get-text">Email (optional)</p>
                      <input
                        type="text"
                        name="email"
                        value={values.email}
                        onChange={changeHandler}
                        onBlur={handleBlur}
                        maxLength={limits.email.max}
                        className={clsx(
                          "form-control bg-transparent",
                          {
                            "is-invalid":
                              touched.email && errors.email && values.email,
                          },
                          {
                            "is-valid":
                              touched.email && !errors.email && values.email,
                          },
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
              {/* ── Address Details ────────────────────────────────── */}
              <div className="row each-row">
                <h5>Address</h5>
                <div className="col-md-4 mb-3" id="country">
                  <Form.Group className="form_label">
                    <p className="get-text">
                      Country<span style={{ color: "red" }}>*</span>
                    </p>
                    <select
                      value={values.country}
                      name="country"
                      onChange={countryHandler}
                      className="form-control form-select bg-transparent"
                    >
                      {countryList.map((country) => (
                        <option key={country.code} value={country.name}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                </div>

                <div className="col-md-12 mb-3" id="Address">
                  <Form.Group className="form_label" controlId="Address">
                    <p className="get-text">Address</p>
                    <Autocomplete
                      apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                      onPlaceSelected={(value) => {
                        getSelectedStreet(value, setFieldValue);
                      }}
                      placeholder="Street Address, Company or P.O. box.. "
                      id="address"
                      name="address"
                      className="form-control"
                      options={{
                        types: [],
                        componentRestrictions: {
                          country: values?.country_code?.toLowerCase(),
                        },
                      }}
                      onChange={handleChange}
                      value={values.address}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row each-row">
                <div className="col-md-4 mb-3" id="flat">
                  <Form.Group className="form_label" controlId="flat">
                    <p className="get-text">Unit/Apt No.</p>
                    <input
                      type="text"
                      name="flat"
                      value={values.flat}
                      onChange={handleChange}
                      max={limits.flat}
                      onBlur={handleBlur}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            touched.flat && errors.flat && values.flat !== "",
                        },
                        {
                          "is-valid":
                            touched.flat && !errors.flat && values.flat !== "",
                        },
                      )}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3" id="build">
                  <Form.Group className="form_label" controlId="build">
                    <p className="get-text">
                      Building No.<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="building"
                      value={values.building}
                      onChange={handleChange}
                      max={limits.building}
                      onBlur={handleBlur}
                      className={clsx(
                        "form-control bg-transparent",
                        { "is-invalid": touched.building && errors.building },
                        { "is-valid": touched.building && !errors.building },
                      )}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3" id="street">
                  <Form.Group className="form_label" controlId="street">
                    <p className="get-text">
                      Street Name<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="street"
                      value={values.street}
                      onChange={handleChange}
                      max={limits.street}
                      onBlur={handleBlur}
                      className={clsx(
                        "form-control bg-transparent",
                        { "is-invalid": touched.street && errors.street },
                        { "is-valid": touched.street && !errors.street },
                      )}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row each-row">
                <div className="col-md-4 mb-3" id="city">
                  <Form.Group className="form_label">
                    <p className="get-text">
                      City/Suburb<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="city"
                      value={values.city}
                      onChange={changeHandler}
                      max={limits.city}
                      onBlur={handleBlur}
                      className={clsx(
                        "form-control bg-transparent",
                        { "is-invalid": touched.city && errors.city },
                        { "is-valid": touched.city && !errors.city },
                      )}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3" id="zip">
                  <Form.Group className="form_label">
                    <p className="get-text">
                      Zip/Postal Code
                      {isAfrican === true ? (
                        <></>
                      ) : (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </p>
                    <input
                      type="text"
                      name="postcode"
                      value={values.postcode}
                      onChange={changeHandler}
                      maxLength={limits.other_zip || 10}
                      onBlur={handleBlur}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            touched.postcode &&
                            errors.postcode &&
                            (values.postcode !== "" || undefined || null),
                        },
                        {
                          "is-valid":
                            touched.postcode &&
                            !errors.postcode &&
                            (values.postcode !== "" || undefined || null),
                        },
                      )}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3" id="state">
                  <Form.Group className="form_label">
                    <p className="get-text">
                      State<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="state"
                      value={values.state}
                      onChange={handleChange}
                      max={limits.state}
                      onBlur={handleBlur}
                      className={clsx(
                        "form-control bg-transparent",
                        { "is-invalid": touched.state && errors.state },
                        { "is-valid": touched.state && !errors.state },
                      )}
                    />
                  </Form.Group>
                </div>
              </div>

              {/* ── Action Buttons ─────────────────────────────────── */}
              <div className="row">
                <div className="col-md-4">
                  <button
                    type="button"
                    className="start-form-button full-col"
                    onClick={() => handleCancel()}
                  >
                    {section === "transfer" ? "Back" : "Cancel"}
                  </button>
                </div>
                <div className="col-md-8 full-col">
                  <button
                    className="form-button"
                    style={is_account_existing ? { cursor: "not-allowed" } : {}}
                    disabled={is_account_existing}
                  >
                    {section !== "transfer" ? (
                      <>{id ? "Update" : "Create"} Recipient</>
                    ) : (
                      <>Save & Continue</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </>
  );
};

// ── Shared callout styles ──────────────────────────────────────────
const calloutStyle = {
  flexShrink: 0,
  width: 220,
  background: "#fef0ef",
  border: "1.5px solid #f5c6c6",
  borderLeft: "4px solid #e05555",
  borderRadius: 12,
  padding: "14px 16px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  marginTop: 22,
  animation: "popIn 0.2s ease",
};

const calloutTitleStyle = {
  fontSize: 13,
  fontWeight: 700,
  color: "#d94040",
  marginBottom: 4,
  display: "flex",
  alignItems: "center",
  gap: 6,
};

const calloutBodyStyle = {
  fontSize: 12,
  color: "#4a4a4a",
  lineHeight: 1.5,
  marginBottom: 12,
};

const calloutBtnStyle = {
  background: "#fef0ef",
  color: "#e05555",
  border: "1.5px solid #f5c6c6",
  borderRadius: 7,
  padding: "8px 0",
  fontSize: 12,
  fontWeight: 700,
  fontFamily: "inherit",
  cursor: "pointer",
  width: "100%",
};

export default RecipientForm;
